<template>
  <IQOS required :title="campaign.title">
    <div class="w-100 gap-column-xs mt-16">
      <div class="gap-row-xs w-100">
        <div class="gap-row-zero w-100">
          <div class="iqos-comment qrw-paragraph-md">
            {{ $t("campaign_card.status") }}
          </div>
          <div
            class="iqos-comment"
            :class="{
              'green-6-color': isActive,
            }"
          >
            {{
              isActive
                ? $t("campaign_card.active")
                : $t("campaign_card.not_active")
            }}
          </div>
        </div>

        <div class="gap-row-zero w-100">
          <div class="iqos-comment qrw-paragraph-md">
            {{ $t("campaign_card.period") }}
          </div>
          <div class="qrw-paragraph-md iqos-comment v1-grey-10-color">
            {{ campaign.period_start | formatDate }} -
            {{ campaign.period_end | formatDate }}
          </div>
        </div>
      </div>
      <div class="gap-row-xs w-100">
        <div class="gap-row-zero">
          <div class="iqos-comment qrw-paragraph-md">
            {{ $t("campaign_card.link") }}
          </div>
          <a
            :href="referralLink"
            target="_blank"
            class="qrw-paragraph-md green-6-color"
          >
            {{ referralLink }}
          </a>
        </div>

        <a class="download-link" :href="downloadQrLink" target="_blank">
          <BaseButton
            variant="secondary"
            color="v1-grey-10"
            size="md"
            >{{ $t("campaign_card.download_qr") }}</BaseButton
          >
        </a>
      </div>
    </div>
    <BaseDivider color="v1-grey-4" class="mt-16 mb-16" />
    <div class="stat-box gap-column-xs">
      <div class="stat-item">
        <div class="label qrw-label-sm v1-grey-7-color">
          {{ $t("campaign_card.stat_visits") }}
        </div>
        <div class="number qrw-heading-md v1-grey-10-color">
          {{ campaign.total_visits }}
        </div>
      </div>
      <div class="stat-item">
        <div class="label qrw-label-sm v1-grey-7-color">
          {{ $t("campaign_card.stat_unique") }}
        </div>
        <div class="number qrw-heading-md v1-grey-10-color">
          {{ campaign.unique_visits }}
        </div>
      </div>
      <div class="stat-item">
        <div class="label qrw-label-sm v1-grey-7-color">
          {{ $t("campaign_card.stat_orders") }}
        </div>
        <div class="number qrw-heading-md v1-grey-10-color">
          {{ campaign.total_orders }}
        </div>
      </div>
      <div class="stat-item">
        <div class="label qrw-label-sm v1-grey-7-color">
          {{ $t("campaign_card.stat_sum") }}
        </div>
        <div class="number qrw-heading-md v1-grey-10-color">
          {{ campaign.total_orders_sum || 0 }} {{ currency.symbol }}
        </div>
      </div>
    </div>

    <DangerConfirmModal
      @cancel="deleting = false"
      @confirm="onDelete"
      v-if="deleting"
      >{{ $t("campaign_card_old.confirm_delete") }}</DangerConfirmModal
    >

    <template #actions>
      <BaseButton
        icon="x"
        variant="primary"
        color="red-4"
        size="sm"
        @click="deleting = true"
      />
    </template>
  </IQOS>
</template>
<script>
import ReferralsAPI from "@/api/referrals";

import moment from "moment";

export default {
  data() {
    return {
      deleting: false,
    };
  },
  props: {
    campaign: Object,
  },
  methods: {
    onDelete() {
      ReferralsAPI.removeCampaign(this.campaign._id)
        .then((data) => {
          this.deleting = false;

          this.$store.dispatch("auditlog/write", {
            type: "marketing_remove_campaign",
            payload: {
              title: this.campaign.title,
            },
          });

          this.$emit("deleted");
        })
        .catch((error) => {
          this.$store.dispatch("showError", "referrals_error");
          this.deleting = false;
        });
    },
  },
  computed: {
    referralLink() {
      return `${this.onlineMenuLink}?cmpid=${this.campaign.referral_id}`;
    },
    onlineMenuLink() {
      return this.$store.getters.onlineMenuLink("local");
    },
    downloadQrLink() {
      return `https://api.qrserver.com/v1/create-qr-code/?size=512x512&data=${this.referralLink}`;
    },
    currency() {
      return this.$store.state.currency;
    },
    isActive() {
      return moment().isBetween(
        this.campaign.period_start,
        this.campaign.period_end
      );
    },
  },
};
</script>
<style scoped>
a {
  text-decoration: none;
}

.stat-item {
  width: 100%;
}
</style>
